import React, { Fragment, useState, useEffect, useCallback, useContext, useMemo } from 'react';
import { Form, Row } from 'reactstrap';
import { X } from 'react-feather';
import { Link } from 'react-router-dom';
import CustomContext from '../../_helper/Customizer';
import Leftbar from './Leftbar/index';
import RightHeader from './RightHeader/index';
import { getStoredUser } from '../../api/auth';
import { getMenuForUser } from '../../constants/menuAccess';
import { menuHref } from '../Sidebar/Menu';
import { searchMenuLinks } from './headerMenuSearch';
import { Loading } from '../../Constant';
import SvgIcon from '../../Components/Common/Component/SvgIcon';

const Header = () => {
  const { toggleIcon, layoutURL, customizer } = useContext(CustomContext);
  const mainmenu = useMemo(() => getMenuForUser(getStoredUser()), []);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultEmpty, setSearchResultEmpty] = useState(false);

  const layout_type = customizer.settings.layout_type;

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      removeFix();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  const checkSearchResultEmpty = (items) => {
    const empty = !items.length;
    setSearchResultEmpty(empty);
    const emptyMenu = document.querySelector('.empty-menu');
    if (emptyMenu) {
      emptyMenu.classList.toggle('is-open', empty);
    }
  };

  const addFix = () => {
    document.querySelector('.Typeahead-menu')?.classList.add('is-open');
    document.body.classList.add(`${layout_type}`);
  };

  const removeFix = () => {
    setSearchQuery('');
    setSearchResults([]);
    setSearchResultEmpty(false);
    document.querySelector('.Typeahead-menu')?.classList.remove('is-open');
    document.querySelector('.empty-menu')?.classList.remove('is-open');
    document.body.classList.add(`${layout_type}`);
    document.body.classList.remove('offcanvas');
  };

  const handleSearchKeyword = (keyword) => {
    setSearchQuery(keyword);
    if (!keyword) {
      removeFix();
      return;
    }
    addFix();
    const items = searchMenuLinks(mainmenu, keyword);
    setSearchResults(items);
    checkSearchResultEmpty(items);
  };

  return (
    <Fragment>
      <div className={`page-header ${toggleIcon ? 'close_icon' : ''}`}>
        <Row className='header-wrapper m-0'>
          <Form className='form-inline search-full col' action='#' method='get'>
            <div className='form-group w-100'>
              <div className='Typeahead Typeahead--twitterUsers'>
                <div className='u-posRelative'>
                  <input
                    className='Typeahead-input form-control-plaintext w-100'
                    id='demo-input'
                    type='search'
                    placeholder='Search Credora…'
                    value={searchQuery}
                    onChange={(e) => handleSearchKeyword(e.target.value)}
                  />
                  <div className='spinner-border Typeahead-spinner' role='status'>
                    <span className='sr-only'>{Loading}</span>
                  </div>
                  <X
                    className='close-search'
                    onClick={() => {
                      removeFix();
                      document.querySelector('.search-full')?.classList.remove('open');
                    }}
                  />
                </div>
                <div className='Typeahead-menu' id='search-outer'>
                  <div className='header-search-suggestion custom-scrollbar'>
                    {searchResults.map((data, index) => (
                      <div className='ProfileCard u-cf' key={`${data.path}-${index}`}>
                        <div className='ProfileCard-details'>
                          <div className='ProfileCard-realName'>
                            <Link
                              to={menuHref(data.path, layoutURL)}
                              className='realname w-100 d-flex justify-content-start gap-2'
                              onClick={removeFix}>
                              <SvgIcon
                                style={{ width: '16px', height: '16px' }}
                                className='stroke-icon'
                                iconId={`stroke-${data.icon}`}
                              />
                              <SvgIcon
                                style={{ width: '16px', height: '16px' }}
                                className='fill-icon'
                                iconId={`fill-${data.icon}`}
                              />
                              {data.title}
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className={`Typeahead-menu empty-menu ${searchResultEmpty ? 'is-open' : ''}`}>
                  <div className='tt-dataset tt-dataset-0'>
                    <div className='EmptyMessage'>No matching pages found.</div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
          <Leftbar />
          <RightHeader />
        </Row>
      </div>
    </Fragment>
  );
};

export default Header;
